import React from 'react'
import { Box, Typography } from "@mui/material";
import ac1 from "../img/Activities/1.png";
import ac2 from "../img/Activities/2.png";
import ac3 from "../img/Activities/3.png";
import ac4 from "../img/Activities/4.png";
import ac5 from "../img/Activities/5.png";
import ac6 from "../img/Activities/6.png";
import ac7 from "../img/Activities/Birthday Party Celebration.png";
import ac8 from "../img/Activities/oie_png.png";
import "../../styles/components-styles/ExtraActivities.css"; 

function ExtraActivities() {
  const ClassCard = ({ img, heading }) => (
    <Box className="class-card">
      {heading && <Typography className="class-card-title">{heading}</Typography>}
      <img src={img} alt="" />
    </Box>
  );

  return (
    <Box className="extra-activities-container">
      <Typography className="extra-activities-title">Extra Activities</Typography>
      
      <Box className="extra-activities-box">
        
        <Box className="activity-column purple-bg">
          <ClassCard img={ac1} heading="Celebrations" />
          <br className='between-space'/>
          <br className='between-space'/>
          <ClassCard img={ac4} heading="Celebrations" />
        </Box>

        <Box className="activity-column yellow-bg">
          <ClassCard img={ac2} heading="Greetings and Wishes" />
          <br className='between-space'/>
          <br className='between-space'/>
          <ClassCard img={ac8} heading="Party Scenes" />
        </Box>

        <Box className="activity-column purple-bg">
          <ClassCard img={ac3} heading="Party Scenes" />
          <br className='between-space'/>
          <br className='between-space'/>
          <ClassCard img={ac5} heading="Meditation Session" />
        </Box>

      </Box>
    </Box>
  );
}

export default ExtraActivities